import React from 'react';
import {processLex, genSpeech} from '../state/audio';
import {SERVER} from '../utils';
import styles from './CommandLine.module.css';

const MODES = ['cmd', 'llm']; // web as well

// POST the given command as json to the server
const runCommand = (command: string, mode: string) => {
  fetch(`${SERVER}/command/`, {
    method: "POST",
    body: JSON.stringify({command, mode}),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((resp) => resp.json())
    .then((obj) => {
      console.log('For command, got back', obj);
      switch (obj.mode) {
        case 'cmd':
          processLex(obj);
          break;
        case 'llm':
          genSpeech(obj.llm_output);
          break;
        case 'web':
          //TODO figure out what to do with these
          break;
      }
    });
};

export const CommandLine = () => {
  const [mode, setMode] = React.useState(MODES[0]);
  const [command, setCommand] = React.useState('');
  return (
    <div className={styles.commandline}>
      <input
        type="text"
        value={command}
        onChange={(e) => setCommand(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && runCommand(command, mode)}
        style={{width: '100%'}}
      />
      <ul className={styles.modeList}>
        {MODES.map((m) => (
          <li key={m}>
            <input type="radio" id={m} name="mode" value={m} checked={mode === m} onChange={() => setMode(m)} />
            <label htmlFor={m}>{m}</label>
          </li>
        ))}
      </ul>
      <button onClick={() => runCommand(command, mode)}>Run</button>
    </div>
  );
}
